import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
var useCreatorRatings = function useCreatorRatings() {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    creatorId = _useState2[0],
    setCreatorId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    ratingModalVisible = _useState4[0],
    setRatingModalVisible = _useState4[1];
  var openCreatorRatingModal = function openCreatorRatingModal(id) {
    setCreatorId(id);
    setRatingModalVisible(true);
  };
  var closeCreatorRatingModal = function closeCreatorRatingModal() {
    setRatingModalVisible(false);
  };
  return {
    creatorRatingModal: {
      props: {
        visible: ratingModalVisible,
        creatorId: creatorId,
        onCancel: closeCreatorRatingModal
      },
      openCreatorRatingModal: openCreatorRatingModal
    }
  };
};
export default useCreatorRatings;